import type { ReactNode } from "react";
import { highlightSegments } from "./highlightSegments";

/** Wraps the matches of `query` in <mark>, ignoring case and accents. */
export function highlight(text: string, query: string): ReactNode {
  const segments = highlightSegments(text, query);
  if (segments.length === 0) return text;
  return segments.map((segment) =>
    segment.match ? (
      <mark className="nb-hl" key={segment.start}>
        {segment.text}
      </mark>
    ) : (
      segment.text
    ),
  );
}
